import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateScopes } from '@cloud-twin-v2/cloud-twin-shared/core/translate-scopes';
import { MasterOperatorWorkspace } from '../models/master-operator-workspace';

const COMPONENT_SELECTOR = 'tc-master-operator-workspace-popup';

@Component({
    selector: COMPONENT_SELECTOR,
    templateUrl: './master-operator-workspace-popup.component.html',
    styleUrls: ['./master-operator-workspace-popup.component.scss'],
    standalone: false
})
export class MasterOperatorWorkspacePopupComponent implements OnInit {
  dialogData: { canClose: boolean };
  isValid: boolean;
  model: MasterOperatorWorkspace;
  readonly T_SCOPE = `${TranslateScopes.MasterOperator}.${COMPONENT_SELECTOR}`;

  constructor(
    private _dialogRef: MatDialogRef<MasterOperatorWorkspacePopupComponent>,
    @Inject(MAT_DIALOG_DATA) dialogData: { canClose: boolean }
  ) {
    this.dialogData = dialogData;
  }

  ngOnInit(): void {}

  onSubmit(): void {
    if (this.isValid) {
      this.onClose(this.model);
    }
  }

  onIsValid(isValid: boolean): void {
    this.isValid = isValid;
  }

  onValueChanges(model: MasterOperatorWorkspace): void {
    this.model = model;
  }

  onButtonClose(_) {
    this.onClose(null);
  }

  onClose(model: MasterOperatorWorkspace): void {
    this._dialogRef.close(model);
  }
}
